module.exports = __webpack_public_path__ + "static/media/IconTemplates_-10.7807f650.svg";